import { render, staticRenderFns } from "./load-board-overview.vue?vue&type=template&id=7959d185"
import script from "./load-board-overview.vue?vue&type=script&lang=js"
export * from "./load-board-overview.vue?vue&type=script&lang=js"
import style0 from "./load-board-overview.vue?vue&type=style&index=0&id=7959d185&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports